import { compactHeaderStyles as styles } from "@insite/content-library/Pages/CompactHeader";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        ${styles.page?.css}

        z-index: 10;
        .header-search-copy {
            display: none;
        }
    `,
};
